export default {
    label: '波兰语',
    application: {
        name: 'System publikacji informacji',
    },
    ajaxTip: {
        success: 'Sukces',
        error: 'Niepowodzenie',
        noAccess: 'Brak dostępu do tego zasobu',
        notFound: 'Zasób nie istnieje',
        serverBusy: 'Serwer jest zajęty',
        timeOut: 'Przekroczono czas oczekiwania',
    },
    menu: {
        home: 'Strona główna',
        template: 'Zarządzanie szablonami',
        program: 'Zarządzanie programami',
        playplan: 'Plan odtwarzania',
        device: 'Zarządzanie urządzeniami',
        "source-material": 'Zarządzanie materiałami źródłowymi',
        material: 'Materiały',
        checkManage: 'Zarządzanie weryfikacją',
        setting: 'Ustawienia',
        usercenter: "Centrum użytkownika",
        adminManage: "Zarządzanie urządzeniami",
        schedule: "Zadania do wykonania",
        capitalassets: "Zarządzanie aktywami",
        modifyPassword: "Zmień hasło",
        logout: "Wyloguj się",
        "add": "Dodaj",
        "edit": "Edytuj",
        "delete": "Usuń",
        "view": "Zobacz",
        "menu_1": "Strona główna",
        "menu_2": "Zarządzanie urządzeniami",
        "menu_3": "Edytuj (Ustawienia zaawansowane - Edycja podstawowa - Zmień sieć)",
        "menu_4": "Polecenia natychmiastowe",
        "menu_5": "Edytuj (Przenieś departament)",
        "menu_6": "Strategia",
        "menu_7": "Ustawienia głośności",
        "menu_8": "Ustawienia jasności",
        "menu_9": "Ustawienia pobierania",
        "menu_10": "Ustawienia uśpienia",
        "menu_11": "Właściwości urządzenia",
        "menu_12": "Edytuj/Dodaj",
        "menu_13": "Zarządzanie programami",
        "menu_14": "Historia publikacji",
        "menu_15": "Usuń (WSKAZÓWKA/Pojedyncze)",
        "menu_16": "Programy w trakcie publikacji",
        "menu_17": "Grupowanie",
        "menu_19": "Lista programów",
        "menu_20": "Edycja treści",
        "menu_21": "Kopiuj program",
        "menu_23": "Publikuj program",
        "menu_24": "Zarządzanie materiałami",
        "menu_25": "Prześlij",
        "menu_28": "Szybka publikacja",
        "menu_29": "Zarządzanie szablonami",
        "menu_30": "Szablony publiczne",
        "menu_31": "Użyj teraz",
        "menu_32": "Moje szablony",
        "menu_33": "Publikuj do szablonów publicznych",
        "menu_35": "Historia udostępniania",
        "menu_36": "Zarządzanie audytem",
        "menu_37": "Audyt programów",
        "menu_38": "Audyt (Zatwierdź/Odmów)",
        "menu_39": "Audyt materiałów",
        "menu_41": "Historia audytu (Operator)",
        "menu_42": "Historia audytu (Audytor)",
        "menu_43": "Zobacz liczbę zatwierdzeń",
        "menu_44": "Zarządzanie organizacją",
        "menu_45": "Zarządzanie dziennikami",
        "menu_46": "Dzienniki odtwarzania",
        "menu_47": "Dzienniki publikacji",
        "menu_48": "Dzienniki błędów",
        "menu_49": "Dzienniki operacji",
        "menu_50": "Dzienniki plików",
        "menu_51": "Dzienniki logowania",
        "menu_52": "Zatwierdzenie treści",
        "menu_53": "Przestrzeń magazynowania",
        "menu_54": "Struktura organizacyjna",
        "menu_55": "Uprawnienia ról",
        "menu_56": "Autoryzacja",
        "menu_57": "Zobacz (Uprawnienia autoryzacyjne)",
        "menu_58": "Członkowie organizacji",
        "menu_60": "Resetuj hasła użytkowników podwładnych",
        "menu_61": "Zarządzanie aktywami",
        "menu_62": "Mój saldo",
        "menu_63": "Zobacz (Szczegóły środków)",
        "menu_64": "Mój transfer danych",
        "menu_65": "Zobacz (Szczegóły transferu danych)",
        "menu_66": "Kup transfer danych",
        "menu_67": "Moja pojemność",
        "menu_68": "Moje urządzenia",
        "menu_69": "Szczegóły zamówienia",
        "menu_70": "Zobacz (Doładuj)",
        "menu_71": "Zobacz (Kupione szablony)",
        "menu_72": "Zobacz (Kupiony transfer danych)",
        "menu_73": "Inne uprawnienia",
        "menu_74": "Zobacz (Statystyki materiałów i programów)",
        "menu_75": "Zobacz (Aktywa)",
        "menu_76": "Zobacz (Chmowy transfer danych/Statystyki)",
        "menu_77": "Zobacz (Statystyki urządzeń online)"
    },
    login: {
        terminalServiceSystem: 'Inteligentny system usług terminalowych',
        accountLogin: 'Logowanie przez konto',
        register: 'Zarejestruj się',
        accountLoginTip: 'Masz już konto? Zaloguj się',
        scanQRCode: 'Skanuj kod QR',
        readAndAgree: 'Przeczytałem i zgadzam się',
        readAndAgreeLink: 'Regulamin użytkowania',
        readAndAgreeAgreement: 'Proszę przeczytać i zaakceptować regulamin użytkowania',
        forgetpassword: "Zapomniałeś hasła?",
        resetpassword: "Resetuj hasło",
        phoneEmptyTip: "Proszę wprowadzić numer telefonu",
        nextStep: "Następny krok",
        title: 'Witamy, zaloguj się',
        submit: 'Zaloguj się',
        userName: 'Konto',
        password: 'Hasło',
        userNameEmptyTip: 'Proszę wprowadzić nazwę użytkownika',
        passwordEmptyTip: 'Proszę wprowadzić hasło',
        passwordFormatTip: 'Proszę wprowadzić poprawny format hasła',
        passwordIsOk: 'Proszę potwierdzić hasło',
        passwordSign: 'Proszę wprowadzić hasło',
        codeTip: "Proszę wprowadzić kod weryfikacyjny",
        phone: "Numer telefonu nie może być pusty",
        code: "Kod weryfikacyjny nie może być pusty",
        nickname: "Nazwa firmy nie może być pusta",
        pass: "Hasło nie może być puste",
        pwdMessage: "Hasło musi mieć 8~20 znaków, nie może zawierać spacji i musi zawierać co najmniej 3 z następujących elementów: wielkie litery, małe litery, cyfry, znaki specjalne",
        pwdMessage01: "Proszę wprowadzić hasło składające się z liter i cyfr (minimum 8 znaków)",
        pwdMessage02: "Hasło musi mieć 8-20 znaków",
        pwdMessage03: "Hasło nie może zawierać spacji",
        pwdMessage04: "Hasło musi zawierać trzy z następujących elementów: wielkie litery, małe litery, cyfry, znaki specjalne",
        newpassempty: "Nowe hasło nie może być puste",
        newpass: "Dwa hasła nie są zgodne",
        getcode: "Pobierz kod weryfikacyjny",
        format: "Nieprawidłowy format numeru telefonu",
        chongfa: "Ponowne wysłanie za ",
        isSend: 'Wysłano',
        noregister: "Nie masz konta? Zarejestruj się natychmiast",
        Mobile: "Numer telefonu",
        verificationcode: "Kod weryfikacyjny",
        petname: "Pseudonim",
        Quickregistration: "Szybka rejestracja",
        xiugaimima: "Zmień hasło",
        jiumima: "Stare hasło",
        xinmima: "Nowe hasło",
        zaicishuruxinmima: "Ponownie wprowadź nowe hasło",
        xiugaichenggong: "Zmodyfikowano pomyślnie",
        xiugaishoujihao: "Zmień numer telefonu",
        dengluzhanghao: "Konto logowania",
        gongsiid: "ID firmy",
        yonghunicheng: "Pseudonim użytkownika",
        chuangjianshijian: "Czas utworzenia",
        gongsimingcheng: "Nazwa firmy",
        denglumima: "Hasło logowania",
        jianyi: "Zaleca się używanie hasła składającego się z liter i cyfr",
        shezhimima: "Ustaw hasło",
        shezhishoujihao: "Zmień/ustaw numer telefonu",
        yibangding: "Powiązano",
        weibangding: "Nie powiązano",
        zhanghuanquan: "Bezpieczeństwo konta",
        yonghuxinxi: "Informacje o użytkowniku",
        zhuceSucMsg: 'Gratulacje, rejestracja powiodła się!',
        verificationcodeSucMsg: "Kod weryfikacyjny wysłano pomyślnie！",
        requiredIsEmpty: "Pole wymagane nie może być puste！",
        emailObj: {
            title: 'E-mail',
            tit: 'Logowanie przez e-mail',
            tip: 'Proszę wprowadzić adres e-mail',
            formatTip: 'Proszę wprowadzić poprawny format adresu e-mail',
        },
        phoneObj: {
            title: 'Numer telefonu',
            tit: 'Logowanie przez telefon',
            tip: 'Proszę wprowadzić numer telefonu',
            formatTip: 'Proszę wprowadzić poprawny format numeru telefonu',
        },
        emailOrPhoneObj: {
            title: 'E-mail lub numer telefonu',
            tit: 'Logowanie przez e-mail lub telefon',
            tip: 'Proszę wprowadzić e-mail lub numer telefonu',
            formatTip: 'Proszę wprowadzić poprawny format e-maila lub numeru telefonu',
        },
        wechatObj: {
            title: 'WeChat',
            tit: 'Logowanie przez WeChat',
        },
        googleObj: {
            title: 'Google',
            tit: 'Logowanie przez Google',
        },
        confirm: 'Potwierdź',
        confirmSubmit: 'Potwierdź wysłanie',
        cancel: 'Anuluj',
        close: 'Zamknij',
        bindSucMsg: 'Powiązano pomyślnie',
        toContinueBindAccount: 'Kontynuuj, aby zakończyć powiązanie konta trzeciego strony',
        bindTip01: 'Nie masz konta? Zarejestruj jedno',
        bindTip02: 'Masz już konto',
        bindTip03: 'Obecne konto trzeciego strony nie jest powiązane z kontem platformy. Proszę powiązać istniejące konto lub zarejestrować nowe, aby móc logować się szybko w przyszłości.',
        bindTip04: 'Powiąż istniejące konto',
        bindTip05: 'Zarejestruj i powiąż nowe konto',
        bindTip06: 'Zostałeś autoryzowany przez stronę trzecią. Uzupełnij poniższe informacje logowania, aby zakończyć powiązanie',
        bindSubmit: 'Wyślij powiązanie',
        enterAccountTip: 'Proszę wprowadzić nazwę konta',
        RegisterAndBind: 'Zarejestruj i powiąż',
        loginErr: 'Nieprawidłowa nazwa użytkownika lub hasło！',
        usercenter: "Centrum użytkownika",
        pleaseInputName: "Proszę wprowadzić nazwę",
        operationSuccess: "Operacja powiodła się！",
        edit: "Edytuj",
        xiugai: "Modyfikuj",
        userData: "Dane osobowe",
        changePassword: "Zmiana hasła",
        account: "Konto",
        userName01: "Nazwa użytkownika",
        phoneNumber: "Numer telefonu",
        role: "Rola",
        createTime: "Czas utworzenia",
        genghuang: "Zmień",
        bangding: "Powiąż",
        unbind: "Odłącz",
        plesaseSelectBindingType: "Proszę wybrać typ powiązania",
        pleaseConfirmCont: "Proszę potwierdzić, że przeczytałem ten materiał",
        confirmReadCont: "Przeczytałem ten materiał",
        frequentTip: "Operacja wykonywana jest zbyt często, spróbuj ponownie później!",
        zhuxiaoBtn: "Anuluj konto",
        zhuxiaoTitle: "Anulowanie konta",
        querenZhuxiao: "Potwierdź anulowanie",
        jiXu: "Kontynuuj",
        sendCodeBtn: "Wyślij kod weryfikacyjny",
        passwordIsNotOldPassword: "Potwierdzone hasło nie zgadza się z nowym hasłem",
        passwordIsOldPassword: "Nowe hasło jest takie samo jak stare hasło",
        passFormatError: "Proszę wprowadzić poprawny format hasła",
        oldPassWord: "Stare hasło",
        newPassWord: "Nowe hasło",
        inputPlaceholder: 'Proszę wprowadzić',
        confirmPassword: "Potwierdź hasło",
        zhuxiaoTip: `
            1. Anulowanie konta jest nieodwracalne. Po anulowaniu nie będziesz mógł się zalogować ani korzystać z tego konta lub kont trzecich zarejestrowanych za pomocą tego konta. Proszę samodzielnie zapisać wszystkie powiązane informacje i dane.
            2. Przed rejestracją tego konta upewnij się, że wszystkie aktywa zostały wyczyszczone i nie ma żadnych sporów. Po anulowaniu konta uważa się, że zrzekłeś się własności wszystkich aktywów i praw w ramach tego konta, a nie można ich odzyskać ani przywrócić.
            3. Jeśli konto zarejestrowane na ten sam numer telefonu zostanie anulowane累计 3 razy, ten numer telefonu nie będzie można ponownie zarejestrować nowego konta ani powiązać z żadnym innym kontem.
        `
    },
    home: {
        title: "Strona główna",
        quickOperation: "Szybkie operacje",
        addDevice: "Dodaj urządzenie",
        publishProgram: "Opublikuj program",
        publishMaterial: "Opublikuj materiały",
        makeProgram: "Stwórz program",
        uploadMaterial: "Prześlij materiały",
        todayData: "Dane dzisiejsze (aktualizowane co godzinę)",
        playNumChart: "Statystyka liczby odtworzeń",
        deviceOnlineStatus: "Status online urządzeń",
        onLineDevice: "Urządzenia online",
        unLineDevice: "Urządzenia offline",
        programPlayTime: "Statystyka czasu odtwarzania programów",
        downloadSoft: "Pobierz oprogramowanie",
        adminApp: "Aplikacja dla użytkowników mobilnych",
        playerApp: "Terminal odtwarzania publikacji informacji",
        downloadAdminApp: "Kliknij, aby pobrać aplikację użytkownika",
        downloadPlayerApp: "Kliknij, aby pobrać terminal odtwarzania",
        aboutUs: "O nas",
        userManual: "Instrukcja użytkownika",
        message: "Chcę zostawić wiadomość",
    },
    device: {
        inputPlaceholder: 'Proszę wprowadzić',
        selectPlaceholder: 'Proszę wybrać',
        osTypeStr: 'System terminala',
        onLineStatus: 'Status online',
        dpi: 'Rozdzielczość',
        companyDeptIdName: 'Przypisana instytucja',
        deviceGroupIdName: 'Przypisana grupa',
        editOrMove: 'Edytuj/przenieś',
        loanOriginationFee: 'Opłata za pożyczkę',
        strategyInfoLook: 'Wyświetl informacje o strategii',
        programLook: 'Wyświetl programy',
        addEquipments: 'Dodaj urządzenia',
        luminanceSet: 'Kontrola jasności',
        terminal: 'Ustawienia terminala',
        transferCompany: 'Przenieś do innego działu',
        releasedProgram: 'Opublikuj program',
        screenshot: 'Zrzut ekranu',
        changeGroup: 'Zmień grupę',
        defaultGroup: "Domyślna grupa",
        operation: "Operacje",
        edit: "Edytuj",
        saveEdit: "Zapisz edycję",
        add: "Dodaj",
        save: "Zapisz",
        setting: "Ustawienia",
        program: "Programy",
        unbind: "Odłącz",
        sleep: "Uśpij",
        wakeup: "Obudź",
        restart: "Uruchom ponownie",
        shutdown: "Wyłącz",
        reportLog: "Prześlij dzienniki",
        clearPlayData: "Wyczyść dane terminala odtwarzania",
        offlineWarn: "To urządzenie jest offline. Spróbuj ponownie, gdy urządzenie będzie online！",
        confirmUnbind: "Czy na pewno chcesz odłączyć?",
        confirmReset: "Czy na pewno chcesz wyczyścić?",
        confirmDelete: "Czy na pewno chcesz usunąć?",
        delete: "Usuń",
        cancelDelete: "Anuluj usunięcie",
        confirmResetSuccess: "Wyczyszczono pomyślnie",
        confirm: "Potwierdź",
        cancel: "Anuluj",
        operationSuccess: "Operacja powiodła się",
        unbindSuccess: "Odłączono pomyślnie",
        pleaseSelectDevice: "Proszę wybrać urządzenie",
        pleaseSelectOnlineDevice: "Proszę wybrać urządzenie online",
        confirmMixOperation: "Wybrane urządzenia obejmują urządzenia offline. Ustawienia nie będą obowiązywać dla urządzeń offline. Czy na pewno chcesz kontynuować?",
        pleaseSelectDate: "Proszę wybrać datę",
        reportSuccess: "Przesłano pomyślnie",
        deviceSetting: "Ustawienia urządzenia",
        default: "Domyślne",
        all: "Wszystkie",
        deviceList: "Lista urządzeń",
        addDevice: "Dodaj urządzenie",
        department: "Dział/instytucja",
        deviceType: "Rozdzielczość",
        osType: "System terminala",
        onlineState: "Status online",
        online: "Online",
        offline: "Offline",
        notActive: "Nieaktywne",
        search: "Proszę wprowadzić słowo kluczowe",
        batchOperation: "Operacje wsadowe",
        allDevices: "Wszystkie urządzenia",
        deviceAttribute: "Atrybuty urządzenia",
        selectReportDate: "Wybierz datę raportowania",
        inputName: "Proszę wprowadzić nazwę",
        inputWidth: "Proszę wprowadzić szerokość",
        inputHeight: "Proszę wprowadzić wysokość",
        inputResolutionRatio: "Proszę wprowadzić liczbę całkowitą większą od 0！",
        inputSort: "Proszę wprowadzić sortowanie",
        serialNum: "Numer porządkowy",
        name: "Nazwa",
        width: "Szerokość",
        height: "Wysokość",
        resolutionRatio: "Rozdzielczość",
        inputResolutionRatioName: "Proszę wprowadzić nazwę rozdzielczości",
        sort: "Sortowanie",
        personal: "Osobiste",
        system: "Systemowe",
        type: "Typ",
        systemDefaultSettingUneditable: "Domyślne ustawienia systemowe nie można edytować!",
        systemDefaultSettingUnDeletable: "Domyślne ustawienia systemowe nie można usunąć!",
        newz: "Dodaj nowy",
        total: "Razem",
        totalNum: "pozycji",
        strategyName: "Nazwa strategii",
        associatedTerminalNum: "Liczba powiązanych terminali",
        createTime: "Czas utworzenia",
        pleaseSelectStrategy: "Proszę wybrać strategię！",
        onlySelectOneData: "Możesz wybrać tylko jedną pozycję danych！",
        downloadStrategy: "Pobierz strategię",
        inputStrategyName: "Proszę wprowadzić nazwę strategii",
        luminanceControl: "Kontrola jasności",
        volumeStrategy: "Strategia głośności",
        saveSuccess: "Zapisano pomyślnie",
        screenAngle: "Obrót ekranu (°)",
        startTime: "Czas rozpoczęcia",
        endTime: "Czas zakończenia",
        repeat: "Powtarzaj",
        monday: "Poniedziałek",
        tuesday: "Wtorek",
        wednesday: "Środa",
        thursday: "Czwartek",
        friday: "Piątek",
        saturday: "Sobota",
        sunday: "Niedziela",
        everyday: "Codziennie",
        downloadSpeed: "Prędkość pobierania",
        inputDownloadSpeed: "Proszę wprowadzić prędkość pobierania",
        operator: "Operacje",
        pleaseSelectDeleteData: "Proszę wybrać dane do usunięcia！",
        confirmBatchDelete: "Czy na pewno chcesz usunąć wsadowo？",
        pleaseInputName: "Proszę wprowadzić nazwę",
        detailSetting: "Szczegółowe ustawienia",
        weekPlan: "Plan tygodniowy",
        specialDateSetting: "Ustawienia specjalnych dat",
        weekdayInfo: "Dzień tygodnia jest wymagany!",
        volumeInfo: "Głośność jest wymagana!",
        timeError: "Błąd wyboru czasu!",
        editSuccess: "Edycja powiodła się！",
        addSuccess: "Dodawanie powiodło się！",
        addSpecialPlan: "Dodaj specjalny plan strategii",
        downloadSpeedInfo: "Prędkość pobierania: (0 oznacza zakaz pobierania)",
        pleaseSelectStartTime: "Proszę wybrać czas rozpoczęcia",
        pleaseSelectEndTime: "Proszę wybrać czas zakończenia",
        luminanceError: "Proszę wprowadzić poprawną wartość jasności！",
        defaultLuminance: "Domyślna jasność",
        luminance: "Poziom jasności",
        defaultLuminanceInfo: "Domyślna jasność (100 oznacza maksymalną jasność, 0 oznacza całkowite zaciemnienie)",
        volume: "Głośność",
        saveLuminance: "Zapisz jasność",
        changeSuccess: "Zmieniono pomyślnie！",
        changeNetwork: "Zmień sieć",
        netName: "Nazwa sieci",
        nameempty: "Nazwa sieci nie może być pusta",
        currentNetwork: "Bieżąca sieć",
        ipAddress: "Adres IP",
        dailyMode: "Tryb dzienny",
        weeklyMode: "Tryb tygodniowy",
        turnOnTime: "Czas włączenia",
        turnOffTime: "Czas wyłączenia",
        startSleep: "Rozpoczęcie uspienia",
        endSleep: "Zakończenie uspienia",
        batchDelInfo: "Czy na pewno chcesz usunąć zaznaczone pozycje？",
        timeCannotBeEmpty: "Czas nie może być pusty!",
        startUp: "Włącz",
        shutDown: "Wyłącz",
        volumeSize: "Poziom głośności",
        defaultVolume: "Domyślna głośność (100 oznacza maksymalną głośność, 0 oznacza wyciszenie)",
        chooseStartTime: "Proszę wybrać czas rozpoczęcia",
        chooseEndTime: "Proszę wybrać czas zakończenia",
        saveVolume: "Zapisz głośność",
        screenRotationUnSaved: "Obrót ekranu nie został zapisany",
        volumeSettingUnSaved: "Ustawienia głośności nie zostały zapisane",
        luminanceSettingUnSaved: "Ustawienia jasności nie zostały zapisane",
        confirmClosePopup: "Czy na pewno chcesz zamknąć to okno popup?",
        volumeSettingSuccess: "Zmiana głośności powiodła się",
        luminanceSettingSuccess: "Zmiana jasności powiodła się",
        advancedSettingUnSaved: "Ustawienia zaawansowane nie zostały zapisane",
        settingTitle: "Ustawienia terminala",
        volumeSetting: "Ustawienia głośności",
        luminanceSetting: "Ustawienia jasności",
        downloadSetting: "Ustawienia pobierania",
        sleepSetting: "Ustawienia uspienia",
        onOffSetting: "Czasowe włączanie/wyłączanie",
        screenRotation: "Obrót ekranu",
        namingError: "Błąd nazewnictwa, nazwa pliku nie może zawierać spacji！",
        deleteSuccess: "Usunięto pomyślnie",
        deleteFolder: "Usuń folder",
        pleaseInputDeviceName: "Proszę wprowadzić nazwę urządzenia",
        pleaseInputDeviceId: "Proszę wprowadzić ID urządzenia",
        discoverDevice: "Odkryj urządzenie",
        deviceId: "ID urządzenia",
        bound: "Powiązano",
        bind: "Powiąż",
        noDevice: "Brak urządzeń",
        refresh: "Odśwież",
        manualAdd: "Dodaj ręcznie",
        deviceGroup: "Kategoria urządzeń",
        pleaseSelectGroup: "Proszę wybrać grupę！",
        deviceName: "Nazwa urządzenia",
        goAdd: "Przejdź do dodawania",
        close: "Zamknij",
        bindCountInsufficient: "Niewystarczająca liczba możliwych powiązań. Proszę zwiększyć liczbę urządzeń przed dodaniem！",
        displayNumber: "Numer wyświetlany",
        groupName: "Nazwa grupy",
        pleaseSelectGroupName: "Proszę wpisać nazwę grupy！",
        moveGroup: "Przenieś grupę",
        longitude: "Długość geograficzna",
        latitude: "Szerokość geograficzna",
        nationality: "Narodowość",
        province: "Województwo",
        city: "Miasto",
        county: "Powiat",
        outNetIp: "Adres IP zewnętrzny",
        inNetIp: "Adres IP wewnętrzny",
        companyName: "Nazwa firmy",
        Info: "Szczegóły",
        android: "Android",
        win: "Windows",
        osVersion: "Wersja systemu",
        softwareVersion: "Wersja oprogramowania",
        diskSize: "Rozmiar dysku",
        useSize: "Zużyte miejsce",
        macAddr: "Adres MAC",
        longitudeLatitudeInfo: "Długość i szerokość geograficzna muszą być jednocześnie puste lub wypełnione!",
        terminalName: "Nazwa terminala",
        terminalGroup: "Grupa terminali",
        reportJournal: "Czy przesyłać dzienniki",
        systemVersion: "Wersja systemu",
        storageSpace: "Przestrzeń dyskowa",
        resolution: "Rozdzielczość",
        runningMemory: "Pamięć operacyjna",
        model: "Model",
        registerStatus: "Status rejestracji",
        password: "Hasło",
        passwordInfo: "Proszę wprowadzić 6-18 liter lub cyfr!",
        group: "Grupa",
        address: "Adres",
        remark: "Uwagi",
        renewalPeriod: "Okres przedłużenia",
        money: "Koszt",
        latitudeInfo: "Proszę wprowadzić poprawną szerokość geograficzną!",
        totalPayment: "Całkowita kwota",
        longitudeInfo: "Proszę wprowadzić poprawną długość geograficzną!",
        setMeal: "Pakiet",
        number: "Liczba",
        programName: "Nazwa programu",
        playStatus: "Status odtwarzania",
        playType: "Sposób odtwarzania",
        play: "Odtwarzaj",
        pause: "Wstrzymaj",
        playTime: "Czas odtwarzania",
        programDeleted: "Program został usunięty",
        playSuccess: "Program został zaplanowany do odtworzenia",
        pauseSuccess: "Wstrzymano pomyślnie",
        playCycle: "Odtwarzanie cykliczne",
        playInsert: "Wstawiane odtwarzanie",
        withdrawSuccess: "Cofnięto pomyślnie",
        withdrawInfo: "Proszę najpierw wybrać program do cofnięcia！",
        programBelong: "Przypisany program",
        checkAll: "Zaznacz wszystko",
        batchDel: "Usuń wsadowo",
        delConfirm: "Czy na pewno chcesz usunąć zaznaczone pozycje？",
        check: "Zaznaczono",
        noProgram: "Brak programów",
        details: "Szczegóły",
        screenshotFail: "Nie udało się zrobić zrzutu ekranu",
        policyName: "Nazwa polityki",
        terminalNum: "Liczba powiązanych terminali",
        powerStrategy: "Strategia zasilania",
        pleaseSelectDepartment: "Proszę wybrać dział！",
        screenshotControl: "Kontrola zrzutów ekranu",
        未激活: "Nieaktywne",
        已激活: "Aktywne",
        未绑定: "Nie powiązano",
        已绑定: "Powiązano",
    },
    programManage: {
        programList: "Lista programów",
        publishProgram: "Śledzenie publikacji programu",
        week1: "Poniedziałek",
        week2: "Wtorek",
        week3: "Środa",
        week4: "Czwartek",
        week5: "Piątek",
        week6: "Sobota",
        week7: "Niedziela",
        monday: "Poniedziałek",
        tuesday: "Wtorek",
        wednesday: "Środa",
        thursday: "Czwartek",
        friday: "Piątek",
        saturday: "Sobota",
        sunday: "Niedziela",
        name: "Nazwa",
        preview: "Podgląd",
        playDeviceNum: "Liczba urządzeń odtwarzających",
        copyDeviceCode: "Kliknij, aby skopiować",
        osType: "Typ systemu",
        playDate: "Data odtwarzania",
        playWeek: "Tydzień odtwarzania",
        everyday: "Codziennie",
        start: "Od",
        end: "Do",
        playOperateStatusStr: "Status publikacji",
        playDevice: "Urządzenie odtwarzające",
        downloadView: "Pobierz i wyświetl",
        publisher: "Opublikował",
        publishTime: "Czas publikacji",
        operation: "Operacje",
        add: "Dodaj",
        groupName: "Nazwa grupy",
        selectDevice: "Wybierz terminal",
        searchDevice: "Wyszukaj terminal",
        pleaseFillGroupName: "Proszę wpisać nazwę grupy！",
        remarkInfo: "Uwagi",
        compile: "Edytuj",
        withdrawConfirm: "Czy na pewno chcesz cofnąć ten program？",
        confirm: "Potwierdź",
        cancel: "Anuluj",
        withdraw: "Cofnij",
        batchWithdraw: "Cofnij wsadowo",
        batchPublish: "Publikuj wsadowo",
        batchDelete: "Usuń wsadowo",
        batchOperation: "Operacje wsadowe",
        notUse: "Nie używane",
        notChecked: "Nie zweryfikowane",
        notPass: "Odrzucone",
        delete: "Usuń",
        publishTextLeft: "Opublikowano",
        offTextLeft: "Wstrzymano",
        pleaseSelectProgramToMove: "Proszę wybrać program do przeniesienia！",
        pause: "Wstrzymaj",
        pauseConfirm: "Czy na pewno chcesz wstrzymać？",
        play: "Odtwarzaj",
        downloadUdisk: "Pobierz na pendrive",
        deviceList: "Lista urządzeń",
        groupSelection: "Wybór grupy",
        operationSuccess: "Operacja powiodła się",
        deleteSuccess: "Usunięto pomyślnie",
        selectDate: "Wybierz datę",
        publishStatus: "Status publikacji",
        checkStatus: "Status weryfikacji",
        waitAuditing: "Oczekujące na weryfikację",
        auditPass: "Zweryfikowano pomyślnie",
        auditRefuse: "Odrzucono weryfikację",
        all: "Wszystkie",
        playStatus: "Odtwarzanie",
        playStatust: "Status odtwarzania",
        pauseStatus: "Wstrzymane",
        notStartStatus: "Nie rozpoczęte",
        resolutionratio: "Rozdzielczość",
        totalNum: "pozycji",
        programName: "Nazwa programu",
        playStartTime: "Czas rozpoczęcia odtwarzania",
        playEndTime: "Czas zakończenia odtwarzania",
        createTime: "Czas utworzenia",
        nationality: "Narodowość",
        province: "Województwo",
        city: "Miasto",
        county: "Powiat",
        address: "Adres",
        ip: "Adres IP",
        location: "Lokalizacja",
        log: "Dzienniki",
        pleaseFillProgramName: "Proszę wpisać nazwę programu！",
        selectGroup: "Wybierz grupę",
        startTime: "Czas rozpoczęcia",
        endTime: "Czas zakończenia",
        publishCycle: "Cykl publikacji",
        publishDeviceNum: "Liczba urządzeń publikujących",
        pleaseSelectRecord: "Proszę wybrać rekord",
        deviceName: "Nazwa terminala",
        deviceId: "ID urządzenia terminala",
        deviceGroupIdName: "Przypisana grupa",
        notClassified: "Nieklasyfikowane",
        osTypeStr: "System terminala",
        storageSpace: "Przestrzeń dyskowa",
        onLineStatus: "Status online",
        onLine: "Online",
        offLine: "Offline",
        sleep: "Uśpione",
        unknown: "Nieznane",
        registerStatus: "Status rejestracji",
        trialPeriod: "Okres próbny",
        notActive: "Nieaktywne",
        active: "Aktywne",
        parameterError: "Błędne parametry!",
        pleaseSelectProgram: "Proszę wybrać program!",
        pleaseSelectProgramEdit: "Proszę wybrać program do edycji!",
        confirmWithdrawSelectedProgram: "Czy na pewno chcesz cofnąć wybrane programy？",
        withdrawSuccess: "Cofnięto pomyślnie",
        allPrograms: "Wszystkie programy",
        defaultGroup: "Domyślna grupa",
        cannotShareEmptyProgram: "Nie można udostępnić pustego programu！",
        onlyShareYourProgram: "Możesz udostępniać tylko programy, które stworzyłeś!",
        pleaseSelectProgramEditPublishTime: "Proszę wybrać program z edytowanym czasem publikacji!",
        pleaseSelectDevice: "Proszę wybrać urządzenie!",
        programDetail: "Szczegóły programu",
        errorReason: "Przyczyna błędu",
        availableStorageSpaceInsufficient: "Niewystarczająca dostępna przestrzeń dyskowa",
        partialDeviceReleaseFailure: "Publikacja nie powiodła się dla niektórych urządzeń",
        allDeviceReleaseSuccess: "Publikacja powiodła się dla wszystkich urządzeń",
        partialDeviceReleaseSuccess: "Publikacja powiodła się dla niektórych urządzeń",
        allGroup: "Wszystkie grupy",
        allProgram: "Wszystkie programy",
        unGrouped: "Nieprzypisane do grupy",
        replaceProgram: "Zastąp program",
        replaceProgramTip: "Nowo opublikowany program zastąpi istniejące dane programu na terminalu odtwarzania！",
        screen: "Ekran pojedynczy/podwójny",
        singleScreen: "Ekran pojedynczy",
        doubleScreen: "Ekran podwójny",
        playSetting: "Ustawienia odtwarzania",
        batchPlaySetting: "Ustawianie czasu odtwarzania wsadowo",
        individualPlaySetting: "Ustawianie czasu odtwarzania indywidualnie",
        playTime: "Czas odtwarzania",
        daily: "Codziennie",
        weekdays: "Poniedziałek-Piątek",
        monthly: "Bieżący miesiąc",
        advancedSetting: "Ustawienia zaawansowane",
        playProgram: "Odtwarzaj program",
        searchProgram: "Proszę wprowadzić słowo kluczowe",
        shareAddressNotExist: "Adres udostępniania nie istnieje, spróbuj ponownie",
        copySuccess: "Skopiowano pomyślnie",
        shareLink: "Link do udostępnienia",
        publish: "Publikuj",
        noResource: "Brak zasobów",
        single: "Ekran pojedynczy",
        double: "Ekran podwójny",
        time: "Czas",
        associatedTerminalNum: "Liczba powiązanych terminali",
        default: "Domyślne",
        moveGroup: "Przenieś grupę",
        pleaseSelectGroup: "Proszę wpisać nazwę grupy！",
        copy: "Kopiuj",
        FUBEN: "Kopia",
        nameempty: "Nazwa nie może być pusta",
        whitespace: "Błąd nazewnictwa, nazwa pliku nie może zawierać spacji！",
        programWhitespace: "Błąd nazewnictwa, nazwa programu nie może zawierać spacji！",
        pleaseSelectResolution: "Proszę wybrać rozdzielczość！",
        dataError: "Błędne dane！",
        createProgram: "Utwórz nowy program",
        directCreate: "Utwórz bezpośrednio",
        myTemplate: "Moje szablony",
        use: "Użyj",
        free: "Darmowe",
        loadMore: "Załaduj więcej",
        confirmDelete: "Potwierdź usunięcie",
        deleteGroup: "Usuń grupę",
        notPublished: "Nie opublikowano",
        notPassed: "Odrzucone",
        notUsed: "Nie używane",
        confirmDeleteSelectedProgram: "Czy na pewno chcesz usunąć wybrane programy？",
        companyName: "Nazwa firmy",
        programCannotDownload: "Ten program nie może zostać pobrany！",
        publishMaterial: "Opublikuj materiały",
        playMaterial: "Odtwarzaj materiały",
        pleaseInputMaterialName: "Proszę wprowadzić nazwę materiału",
        size: "Rozmiar",
        pleaseInputDeviceName: "Proszę wprowadzić nazwę urządzenia",
        item: "pozycji",
        allMaterial: "Wszystkie materiały",
        allDevices: "Wszystkie urządzenia",
        "saveSuccess": "Zapisano pomyślnie",
        "savefaill": "Błąd zapisu",
        "playMode": "Tryb odtwarzania",
        "cyclePlay": "Odtwarzanie cykliczne",
        "insertPlay": "Odtwarzanie wstawne",
        "noData": "Brak danych",
        "Add": "Dodaj",
        "replace": "Zastąp",
        "repeat": "Powtórz",
        "start01": "Początek",
        "end01": "Koniec",
        "startDate": "Data rozpoczęcia",
        "endDate": "Data zakończenia",
        "useNow": "Użyj natychmiast",
        "fillStartEndTimeFirst": "Wypełnij najpierw czas rozpoczęcia i zakończenia przed dodaniem",
        "fillFullPlayTime": "Wypełnij pełny czas odtwarzania",
        "fillCorrectPlayTime": "Wypełnij poprawny okres odtwarzania",
        "sDateAndEDateBothEmptyOrFilled": "Data rozpoczęcia i data zakończenia muszą być obie puste lub obie wypełnione"
    },
    source: {
        addResource: "Dodaj zasób",
        width: "Szerokość",
        height: "Wysokość",
        size: "Rozmiar (KB)",
        name: "Nazwa",
        pleaseInputResourceName: "Proszę wprowadzić nazwę zasobu！",
        addToGroup: "Dodaj do grupy",
        remark: "Uwagi",
        promptFgIllustrate: "Ilustracja",
        promptFgRealisticPhoto: "Realistyczne zdjęcie",
        promptFgSimplisticDrawing: "Prosty rysunek",
        promptFgChineseStyle: "Styl chiński",
        promptFgPixelArt: "Sztuka pikselowa",
        noModel: "Brak modeli, skontaktuj się z administratorem！",
        getModelFailed: "Nie udało się pobrać modeli, spróbuj ponownie później！ Lub skontaktuj się z administratorem！",
        createImagePrompt: "Generowanie obrazu trwa, proszę nie zamykać！",
        promptEmpty: "Proszę wprowadzić prompt",
        dpiEmpty: "Proszę wybrać proporcje obrazu！",
        fgEmpty: "Proszę wybrać styl！",
        style: "Styl",
        idEmpty: "ID obrazu nie może być puste",
        exist: "Ten obraz już istnieje w materiałach",
        addSuccess: "Dodano materiały pomyślnie",
        saveError: "Nie udało się zapisać obrazu, spróbuj ponownie później！",
        delSuccess: "Usunięto pomyślnie",
        generateImage: "Tekst na obraz",
        generateImagePlaceholder: 'Proszę wprowadzić opis obrazu, np.: Motyl tańczący wśród kwiatów',
        aiExpand: "Inteligentne rozszerzanie",
        negativePrompt: "Negatywny prompt",
        negativePromptTooltip: "Używane do wyraźnego wykluczenia treści lub cech, których użytkownik nie chce widzieć w wynikach",
        imageRatio: "Proporcje obrazu",
        generateImageBtn: "Generuj natychmiast",
        shengchengjieguo: "Wyniki generowania",
        generateImageLoadingTip: "Generowanie trwa, proszę nie klikać ponownie ani nie zamykać...",
        Tooltip: "Przekształć swoją kreatywność za pomocą AI",
        saveToMaterial: "Zapisz do materiałów",
        publish: "Opublikuj natychmiast",
        download: "Pobierz",
        generateHistory: "Historia generowania",
        hide: "Ukryj",
        cancel: "Anuluj",
        useExpand: "Użyj rozszerzenia",
        all: "Wszystkie",
        delete: "Usuń",
        loadMore: "Załaduj więcej",
        aiTip: "Zawartość generowana przez model sztucznej inteligencji nie odzwierciedla poglądów, stanowiska ani opinii platformy. Proszę korzystać z treści AI w sposób zgodny z przepisami i regulaminami",
        operationSuccess: "Operacja powiodła się",
        moveGroup: "Przenieś grupę",
        groupName: "Nazwa grupy",
        pleaseSelectGroup: "Proszę wybrać nazwę grupy！",
        shenhe: "Weryfikuj",
        shenheStatus: "Status weryfikacji",
        shenheSuccess: "Weryfikacja powiodła się",
        shenheRefuse: "Weryfikacja odrzucona",
        pleaseSelectShenheStatus: "Proszę wybrać status weryfikacji！",
        shenheRemark: "Uwagi do weryfikacji",
        pleaseInputShenheRemark: "Proszę wprowadzić uwagi do weryfikacji！",
        pleaseInputFileName: "Proszę wprowadzić nazwę pliku！",
        whitespace: "Błąd nazewnictwa, nazwa pliku nie może zawierać spacji！",
        dataError: "Błędne dane！",
        confirmDelete: "Potwierdź usunięcie",
        confirm: "Potwierdź",
        deleteFolder: "Usuń folder",
        add: "Dodaj",
        edit: "Edytuj",
        fileName: "Nazwa pliku",
        group: "Grupa",
        resolution: "Rozdzielczość",
        type: "Typ",
        image: "Obraz",
        music: "Muzyka",
        video: "Wideo",
        uploadTime: "Czas przesłania",
        uploadUser: "Przesłał",
        checkTime: "Czas weryfikacji",
        checkUser: "Weryfikował",
    },
    setting: {
        nameempty: "Nazwa nie może być pusta",
        heightempty: "Wysokość nie może być pusta",
        widthempty: "Szerokość nie może być pusta",
        resolutionratio: "Rozdzielczość",
        name: "Nazwa",
        opteration: "Operacje",
        compile: "Edytuj",
        delete: "Usuń",
        newz: "Dodaj nowy",
        compileratio: "Edytuj rozdzielczość",
        sheizhifenbianlvmingcheng: "Ustaw nazwę rozdzielczości",
        shezhigaodu: "Ustaw wysokość",
        shezhikuandu: "Ustaw szerokość",
        xinzengfenbianlv: "Dodaj nową rozdzielczość",
        bianma: "Kodowanie",
        bianjizhongduanmingcheng: "Edytuj nazwę terminala",
        xinzengzhongduan: "Dodaj nowy terminal",
        selectPrimaryColor: 'Wybierz kolor motywu',
        fullScreen: 'Pełny ekran',
        exitFullScreen: 'Wyjdź z trybu pełnoekranowego',
    },
    tabs: {
        refresh: 'Odśwież',
        refreshAll: 'Odśwież wszystko',
        close: 'Zamknij',
        closeOthers: 'Zamknij inne',
        closeAll: 'Zamknij wszystko',
        closeLeft: 'Zamknij lewe',
        closeRight: 'Zamknij prawe',
    },
    errorPage: {
        needLogin: 'Nie jesteś zalogowany！',
        pageNotFound: 'Strona, do której próbujesz uzyskać dostęp, nie istnieje！',
        redirectTo: 'Przekieruj do',
        orReturn: 'lub wróć do',
        previousStep: 'Poprzedni krok',
    },
    headerUs: {
        systemNotice: "Powiadomienia systemowe",
        allNotices: "Wszystkie powiadomienia",
        viewAllMessages: "Wyświetl wszystkie wiadomości",
        contactUs: "Skontaktuj się z nami",
        operationSuccess: "Operacja powiodła się！",
        leaveMessage: "Chcę zostawić wiadomość",
        messageTitle: "Tytuł",
        messageTitleTip: "Proszę wprowadzić tytuł！",
        messageContentTip: "Maksymalnie 150 znaków",
        submit: "Wyślij",
        markAsRead: "Oznacz jako przeczytane",
        success: "Operacja powiodła się！"
    },
    material: {
        allMaterial: "Wszystkie materiały",
        defaultGroup: "Domyślna grupa",
        auditStatus: "Status weryfikacji",
        auditPassed: "Weryfikacja powiodła się",
        auditRejected: "Weryfikacja odrzucona",
        pendingAudit: "Oczekujące na weryfikację",
        all: "Wszystkie",
        operateSuccess: "Operacja powiodła się！",
        pleaseSelectMaterial: "Proszę wybrać materiały！",
        moveGroup: "Przenieś grupę",
        pleaseSelectGroup: "Proszę wybrać grupę！",
        batchPublish: "Publikuj wsadowo",
        batchRecall: "Cofnij wsadowo",
        batchDelete: "Usuń wsadowo",
        materialList: "Lista materiałów",
        uploadMaterial: "Prześlij materiały",
        materialType: "Typ materiału",
        pleaseInputMaterialName: "Proszę wprowadzić nazwę materiału",
        selectAll: "Zaznacz wszystko",
        confirmDeleteSelectedMaterial: "Czy na pewno chcesz usunąć zaznaczone materiały？",
        deleteSuccess: "Usunięto pomyślnie",
        delete: "Usuń",
        publish: "Publikuj",
        recall: "Cofnij",
        confirmRecallSelectedMaterial: "Czy na pewno chcesz cofnąć zaznaczone materiały？",
        pleaseSelectMaterialGroup: "Proszę wybrać grupę materiałów！",
        recallSuccess: "Cofnięto pomyślnie",
        publishSuccess: "Publikowano pomyślnie",
        batchOperate: "Operacje wsadowe",
        item: "pozycji",
        confirmDelete: "Czy na pewno chcesz usunąć？",
        edit: "Edytuj",
        confirmRecall: "Czy na pewno chcesz cofnąć？",
        unaudited: "Niezweryfikowane",
        notPassed: "Odrzucone",
        operate: "Operacje",
        resolution: "Rozdzielczość",
        none: "Brak",
        confirm: 'Potwierdź',
        cancel: 'Anuluj',
        AICreation: "Twórczość AI",
    },
    uploadFile: {
        operationSuccess: "Operacja powiodła się",
        uploadFile: "Zarządzanie przesyłaniem",
        uploadSuccess: "Przesłano pomyślnie",
        uploadCompleted: "Przesyłanie ukończone",
        uploadFail: "Przesyłanie nie powiodło się",
        ConversionFailed: "Konwersja nie powiodła się！",
        loading: "Ładowanie trwa...",
        beQueuing: "W kolejce...",
        Uploading: "Przesyłanie...",
        ConversionIng: "Konwersja...",
        ConventionalResources: "Zasoby standardowe",
        DocumentResources: "Zasoby dokumentów",
        complete: "Ukończono",
        upload: "Prześlij",
        fileSizeWraning01: "Rozmiar materiału przekracza",
        fileSizeWraning02: "Proszę zmodyfikować i przesłać ponownie！",
        fileIsEmpty: "Plik jest pusty",
        uploadFileTip: "Nieobsługiwany format pliku",
        unablePreview: "Nie udało się dodać do biblioteki materiałów, podgląd niemożliwy",
        confirmDelete: "Czy na pewno chcesz usunąć？",
        deleteSuccess: "Usunięto pomyślnie",
        delete: "Usuń",
        confirm: "Potwierdź",
        preview: "Podgląd",
        close: "Zamknij",
        cancel: "Anuluj",
        fileType: "Typ pliku",
        fileSize: "Rozmiar pliku",
        conversionProgress: "Postęp konwersji",
        progress: "Postęp",
        image: "Obraz",
        video: "Wideo",
        audio: "Muzyka",
        limitTip01: "Jednorazowe przesłanie",
        limitTip02: "plików",
        okTip: "Przesyłanie materiałów trwa, proszę nie zamykać！",
        usableSize: 'Dostępna pojemność',
        sizeUnableTip: "Bieżąca dostępna przestrzeń dyskowa jest niewystarczająca. Proszę regularnie czyścić nieużywane materiały, aby zaoszczędzić miejsce lub skontaktować się z dystrybutorem w celu rozszerzenia pojemności magazynu w chmurze. Usługa może wiązać się z kosztami, szczegóły u dystrybutora.",
        view: "Wyświetl szczegóły",
        fileName: "Nazwa pliku",
    },
    template: {
        inputPlaceholder: 'Proszę wprowadzić',
        selectPlaceholder: 'Proszę wybrać',
        noAuths: "Brak uprawnień, skontaktuj się z administratorem",
        operationSuccess: "Operacja powiodła się",
        total: "Razem",
        totalNum: "pozycji",
        dan: "Pojedynczy",
        shaung: "Podwójny",
        pleaseSelectGroup: "Proszę wybrać grupę",
        preview: "Podgląd",
        free: "Darmowe",
        use: "Użyj",
        dpi: 'Rozdzielczość',
        delete: "Usuń",
        confirmDelete: "Potwierdź usunięcie",
        confirmDeleteSelectedTemplate: "Czy na pewno chcesz usunąć ten szablon",
        push: "Publikuj",
        pushConfirm: "Czy na pewno chcesz opublikować w szablonach publicznych",
        pushRemovalConfirm: "Czy na pewno chcesz wycofać z szablonów publicznych",
        templateOrderRecord: "Rekordy zamówień szablonów",
        unpublished: "Nie opublikowano",
        auditing: "Weryfikacja trwa",
        publishRejected: "Publikacja odrzucona",
        publishSuccess: "Publikowano pomyślnie",
        offShelf: "Wycofaj z oferty",
        公共模版: "Szablony publiczne",
        我的模板: "Moje szablony",
        共享记录: "Rekordy udostępnień",
        name: "Nazwa",
        pubdate: "Czas publikacji",
        keySeachTip: "Proszę wprowadzić słowo kluczowe",
        allGroup: "Wszystkie grupy",
        add: "Dodaj",
        edit: "Edytuj",
        programName: "Nazwa programu",
        selectGroup: "Wybierz grupę",
    },
    checkManage: {
        total: "Razem",
        totalNum: "pozycji",
        operationSuccess: "Operacja powiodła się",
        checkUserLogs: "Rekordy weryfikacji (operator)",
        checkLogs: "Rekordy weryfikacji (brygadzista)",
        sourceCheck: "Weryfikacja materiałów",
        programCheck: "Weryfikacja programów",
        checkAll: "Zaznacz wszystko",
        auditPass: "Weryfikacja powiodła się",
        auditRefuse: "Weryfikacja odrzucona",
        auditPass01: "Zaakceptowano",
        auditRefuse01: "Odrzucono",
        auditRefuse02: "Odrzuć weryfikację",
        auditor: "Brygadzista",
        agentUserName: "Opublikował",
        interrogationTime: "Czas zgłoszenia do weryfikacji",
        checkTime: "Czas weryfikacji",
        checkName: "Nazwa weryfikacji",
        checkType: "Kategoria weryfikacji",
        checkIp: "Adres IP zgłoszenia do weryfikacji",
        checkReason: "Wiadomość",
        checkStatus: "Zawartość operacji",
        rangePicker: "Data weryfikacji",
        keyWord: "Słowo kluczowe",
        all: "Wszystkie",
        program: 'Program',
        material: 'Materiały',
        dan: "Pojedynczy",
        shaung: "Podwójny",
        pleaseSelectProgram: "Proszę wybrać program!",
        pleaseSelectMaterial: "Proszę wybrać materiały！",
        preview: "Podgląd",
        dpi: 'Rozdzielczość',
        auditRefuseTip: "Proszę wprowadzić przyczynę odrzucenia",
        unreviewed: "Niezweryfikowane",
        notPassed: "Odrzucone",
        notUsed: "Nie używane",
        edit: "Edytuj",
        none: "Brak",
        name: "Nazwa",
        size: "Rozmiar",
        type: "Typ",
        uploadTime: "Czas przesłania",
        uploadUser: "Przesłał",
        checkUser: "Weryfikował",
        image: "Obraz",
        music: "Muzyka",
        video: "Wideo",
    },
    systemSet: {
        total: "Razem",
        totalNum: "pozycji",
        inputPlaceholder: 'Proszę wprowadzić',
        selectPlaceholder: 'Proszę wybrać',
        userList: "Członkowie organizacji",
        roleList: "Uprawnienia ról",
        department: "Struktura organizacyjna",
        diskInfo: "Przestrzeń dyskowa",
        approveSet: "Weryfikacja treści",
        logList: "Zarządzanie dziennikami",
        name: "Imię i nazwisko",
        account: "Konto",
        userName: "Imię i nazwisko użytkownika",
        phoneNumber: "Numer telefonu",
        role: "Rola",
        createTime: "Czas utworzenia",
        operation: "Operacje",
        edit: "Edytuj",
        delete: "Usuń",
        addNew: "Dodaj nowy",
        add: "Dodaj",
        resetPassword: "Resetuj hasło",
        confirmDelete: "Czy na pewno chcesz usunąć",
        departmentOrganization: "Dział/instytucja",
        addNewUser: "Dodaj nowego użytkownika",
        pleaseEnterUserName: "Proszę wprowadzić imię i nazwisko użytkownika",
        confirmPasswordNotMatch: "Potwierdzone hasło nie zgadza się z hasłem!",
        operationSuccess: "Operacja powiodła się！",
        userNickname: "Nazwa użytkownika",
        pleaseEnterUserNickname: "Proszę wprowadzić nazwę użytkownika",
        userNicknameRequired: "Nazwa użytkownika nie może być pusta！",
        password: "Hasło",
        pleaseEnterPassword: "Proszę wprowadzić hasło",
        passwordRequired: "Hasło nie może być puste！",
        passwordTip: "Twoje hasło ma zbyt niskie bezpieczeństwo (hasło musi zawierać co najmniej 3 z następujących elementów: wielkie litery, małe litery, cyfry, znaki specjalne i mieć długość od 8",
        confirmPassword: "Potwierdź hasło",
        pleaseEnterPhoneNumber: "Proszę wprowadzić numer telefonu",
        phoneNumberRequired: "Numer telefonu nie może być pusty！",
        phoneNumberFormatError: "Proszę wprowadzić poprawny numer telefonu！",
        roleRequired: "Rola nie może być pusta！",
        required: "Nie może być puste！",
        departmentName: "Dział",
        modifyPassword: "Zmień hasło",
        newPassword: "Nowe hasło",
        pleaseEnterNewPassword: "Proszę wprowadzić nowe hasło",
        pwdMessage: "Hasło musi mieć 8~20 znaków, nie może zawierać spacji i musi zawierać co najmniej 3 z następujących elementów: wielkie litery, małe litery, cyfry, znaki specjalne",
        all: "Wszystkie",
        noAuths: "Brak uprawnień, skontaktuj się z administratorem",
        departmentName01: "Nazwa działu",
        image: "Obraz",
        music: "Muzyka",
        video: "Wideo",
        buySize: "Liczba zakupionych jednostek",
        totalMoney: "Kwota opłaty",
        buycreateTime: "Czas zakupu",
        endTime: "Czas wygaśnięcia",
        buyTypeStr: "Typ zamówienia",
        sourceCheck: "Weryfikacja materiałów",
        programCheck: "Weryfikacja programów",
        programName: "Nazwa programu",
        diskExpansion: "Zaleca się regularne czyszczenie przedawnionych/nieużywanych materiałów w celu zapewnienia dostępnej przestrzeni systemowej. Jeśli potrzebujesz większej przestrzeni, możesz skontaktować się z dostawcą urządzeń w celu uzyskania usługi rozszerzenia pojemności magazynu w chmurze. Usługa może wiązać się z kosztami, szczegóły u dystrybutora.",
        selectPermission: "Proszę wybrać uprawnienia",
        checkPermission: "Proszę zaznaczyć uprawnienia",
        addRole: "Dodaj rolę",
        enterRoleName: "Proszę wprowadzić nazwę roli",
        roleName: "Nazwa roli",
        roleNameRequired: "Nazwa roli nie może być pusta！",
        remark: "Uwagi",
        enterRemark: "Proszę wprowadzić uwagi",
        permissionSetting: "Ustawienia uprawnień",
        deleteSuccess: "Usunięto pomyślnie！",
        confirmToDelete: "Czy na pewno chcesz usunąć？",
        orgName: "Nazwa instytucji",
        orgNameRequired: "Nazwa instytucji nie może być pusta！",
        orgRemark: "Uwagi do instytucji",
        enterOrgRemark: "Proszę wprowadzić uwagi do instytucji",
        capacityUsage: "Stan wykorzystania pojemności",
        usedCapacity: "Zużyta pojemność",
        totalCapacity: "Całkowita pojemność",
        remainingCapacity: "Pozostała pojemność",
        capacityExpansion: "Rozszerzenie pojemności",
        enable: "Włącz",
        disable: "Wyłącz",
        userName01: "Nazwa użytkownika",
        loginTime: "Czas logowania",
        ipAddress: "Adres IP",
        loginResult: "Wynik logowania",
        selectDate: "Wybierz datę",
        enterDate: "Proszę wybrać datę",
        selectStartTime: "Proszę wybrać czas rozpoczęcia",
        selectEndTime: "Proszę wybrać czas zakończenia",
        enterUserName: "Proszę wprowadzić nazwę użytkownika",
        userCount: "Liczba użytkowników",
        roleDesc: "Opis roli",
        roleAuthorization: "Autoryzacja roli",
        success: "Sukces",
        failure: "Niepowodzenie",
        time: "Czas",
        operationContent: "Zawartość operacji",
        playCount: "Liczba odtworzeń",
        playDuration: "Czas odtwarzania",
        selectDevice: "Wybierz urządzenie",
        enterProgramName: "Proszę wprowadzić nazwę programu",
        serialNumber: "Numer porządkowy",
        publishContentName: "Nazwa opublikowanej treści",
        playMode: "Sposób odtwarzania",
        cyclePlay: "Odtwarzanie cykliczne",
        insertPlay: "Wstawiane odtwarzanie",
        paddingPlay: "Odtwarzanie wypełniające",
        playDeviceId: "ID urządzenia odtwarzającego",
        playDeviceName: "Nazwa urządzenia odtwarzającego",
        publishTime: "Czas publikacji",
        downloadStatus: "Status pobierania",
        notDownloaded: "Nie pobrano",
        downloading: "Pobieranie",
        downloadSucceeded: "Pobrano pomyślnie",
        downloadFailed: "Pobieranie nie powiodło się",
        enterPublishContentName: "Proszę wprowadzić nazwę opublikowanej treści",
        terminalId: "ID terminala",
        belongOrg: "Przypisana instytucja",
        reportTime: "Czas raportowania",
        reportIp: "IP raportowania",
        logInfo: "Informacje dziennika",
        details: "Szczegóły",
        confirmDeletion: "Czy na pewno chcesz usunąć？",
        logDetails: "Szczegóły dziennika",
        download: "Pobierz",
        deptOrg: "Dział/instytucja",
        query: "Wyszukaj",
        queryByTerminalId: "Wyszukaj po ID terminala",
        batchDeleteLogs: "Usuń dzienniki wsadowo",
        customTimeDeleteLogs: "Usuń dzienniki w określonym czasie",
        selectTimeRangeFirst: "Proszę najpierw wybrać zakres czasu",
        deleteAllDeviceLogsIfEmpty: "Jeśli nie wpiszesz ID urządzenia, domyślnie zostaną usunięte dzienniki wszystkich urządzeń",
        enterDeviceIdToDeleteLogs: "Proszę wprowadzić ID urządzenia, dla którego chcesz usunąć dzienniki",
        confirmDeleteAction: "Potwierdź usunięcie",
        selectDeleteRangeFirst: "Proszę najpierw wybrać zakres usuwania",
        networkConnectionFailed: "Nie udało się połączyć z siecią",
        playLog: "Dzienniki odtwarzania",
        publishLog: "Dzienniki publikacji",
        errorLog: "Dzienniki błędów",
        operationLog: "Dzienniki operacji",
        fileLog: "Dzienniki plików",
        userOperateLog: "Dzienniki logowań",
    },
    userManual: {
        userManual: "Instrukcja użytkownika",
        noData: "Brak danych",
    },
    systemNotice: {
        systemNotice: "Powiadomienia systemowe",
        noData: "Brak danych",
        total: "Razem",
        totalNum: "pozycji",
        "markAllRead": "Oznacz wszystko jako przeczytane",
        "deleteAll": "Usuń wszystko",
        "all": "Wszystkie",
        "unread": "Nieprzeczytane",
        "read": "Przeczytane",
        "type": "Typ",
        "content": "Zawartość",
        "date": "Data",
        "status": "Status",
        "confirmDelete": "Czy na pewno chcesz usunąć？",
        "confirm": "Potwierdź",
        "cancel": "Anuluj",
        "delete": "Usuń"
    }
};